import { MeasurementQueryRequest } from '@scaleaq/sitecontrol-lib';

import { BoxPlotChartBoxConfigType } from '../types.ts';

type BoxPlotMeasurementRange = {
  start: string;
  end: string;
};

/**
 * Maps a chart box to a measurement query. Widget `sensorId` is the sensor inventory
 * node, not the site; the measurement API names that field `inventoryId`. Live and
 * historical callers differ only by the date range they pass.
 */
export const boxPlotBoxToMeasurementQuery = (
  box: Pick<BoxPlotChartBoxConfigType, 'sensorId' | 'provider'>,
  range: BoxPlotMeasurementRange
): MeasurementQueryRequest => ({
  start: range.start,
  end: range.end,
  inventoryId: box.sensorId,
  provider: box.provider,
  includeSubSensors: true,
  mergeSeries: true,
});
